
import { defineComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import BillingTemplatesList from '@/components/billing-templates/list.vue'
import { OrganizationsRouteNames } from '@/router/routes-names'

export default defineComponent({
    name: 'organizations-billing-templates-list',
    components: { BillingTemplatesList },
    props: {
        organizationId: {
            type: String,
            required: true
        }
    },
    setup (props) {
        const router = useRouter()
        const route = useRoute()

        const onAddBillingTemplate = () => {
            router.push({
                name: OrganizationsRouteNames.BILLING_TEMPLATE_NEW,
                params: { organizationId: props.organizationId },
                query: { page: route.query.page || '1' }
            })
        }

        return {
            onAddBillingTemplate
        }
    }
})
